import * as stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  input: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  label: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-5'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '16px',
    color: colors.secondaryText,
    marginBottom: '2px',
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  inputField: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    backgroundColor: colors.primaryBackground,
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    outline: 'none',
    padding: '8px 36px 8px 16px',
    boxSizing: 'border-box',
    width: '100%',
    height: '36px',
    '::placeholder': {
      color: colors.ghostText,
    },
  },
  inputError: {
    borderColor: colors.errorBorder,
    ':focus': {
      borderColor: colors.errorBorder,
    },
  },
  clearButton: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '4px',
    background: 'transparent',
    border: 'none',
  },
  errorMessage: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: '12px',
    color: colors.errorText,
    position: 'absolute',
    bottom: '-14px',
    left: 0,
  },
});
